import { getConfig, getVariableValue, getVariableVariable, isWeb } from "@tamagui/core";
const getFontTokens = (fontKey = "$body") => getConfig().fontsParsed[fontKey],
  getFontSizeTokens = (fontKey = "$body") => getFontTokens(fontKey).size,
  getLineHeightTokens = (fontKey = "$body") => getFontTokens(fontKey).lineHeight,
  getLetterSpacingTokens = (fontKey = "$body") => getFontTokens(fontKey).letterSpacing,
  getFontWeightTokens = (fontKey = "$body") => getFontTokens(fontKey).weight,
  getFontTokenKeys = (fontKey = "$body") => {
    const fontSizeTokens = getFontSizeTokens(fontKey);
    return Object.keys(fontSizeTokens);
  },
  getTypographyCSSVariable = (token, property, fontKey = "$body") => getVariableVariable(getFontTokens(fontKey)[property]?.[token]),
  getFontName = (weight = "400", fontKey = "$body", isForWeb = isWeb) => {
    if (isForWeb) {
      const family = getFontTokens(fontKey).family;
      return getVariableValue(family);
    }
    const fontFace = getFontTokens(fontKey).face?.[weight]?.normal;
    return getVariableValue(fontFace);
  },
  getTypographyValue = (token, property, fontKey = "$body") => {
    const variable = getFontTokens(fontKey)[property]?.[token];
    return getVariableValue(variable);
  };
export { getFontName, getFontSizeTokens, getFontTokenKeys, getFontTokens, getFontWeightTokens, getLetterSpacingTokens, getLineHeightTokens, getTypographyCSSVariable, getTypographyValue };